
import { query, params, types, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _emergencyInitQuery = (id: string) => ({
  organisations_by_pk: params(
    {
      id: rawString(id),
    },
    {
      name: types.string,
      categories: [{
        id: types.string,
        name: types.string,
      }],
      emergency_roles: [{
        id: types.string,
        name: types.string,
        order_index: types.number,
      }],
    },
  )
});

type X = Unpacked<typeof _emergencyInitQuery>;
export type Organisation = X['organisations_by_pk'];

export const emergencyInitQuery = (id: string) => gql`${query(_emergencyInitQuery(id))}`;
